export const ABSOLUTE_PORTAL_GAP = 4
